"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMultipleQuotesSchema = exports.SendQuoteSchema = exports.QuoteInvoiceBreakdownResponseSchema = exports.QuoteInvoiceBreakdownSchema = exports.CustomerInvoiceBreakdownSchema = exports.SaveQuoteSignatureRequestSchema = exports.QuoteStatusResponseSchema = exports.QuoteStatusRequestSchema = exports.FullQuoteResponseSchema = exports.FullQuoteSchema = exports.QuoteStep3RequestSchema = exports.QuotesDetailsResponseSchema = exports.QuoteDetailsSchema = exports.QuoteStep2RequestSchema = exports.GetQuoteStep1Response = exports.GetQuotesQuerySchema = exports.GetQuotesResponseSchema = exports.QuoteOverviewSchema = exports.CreateQuoteResponseSchema = exports.CreateQuoteRequestSchema = exports.QuoteCustomerParams = exports.QuoteDetailsParams = void 0;
const zod_1 = require("zod");
const address_types_1 = require("./address.types");
const attachment_types_1 = require("./attachment.types");
const customer_types_1 = require("./customer.types");
const invoices_types_1 = require("./invoices.types");
const priceBook_types_1 = require("./priceBook.types");
const sharedStatus_types_1 = require("./sharedStatus.types");
const tax_types_1 = require("./tax.types");
exports.QuoteDetailsParams = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.QuoteCustomerParams = zod_1.z.object({
    quoteId: zod_1.z.string(),
    customerId: zod_1.z.string(),
});
exports.CreateQuoteRequestSchema = zod_1.z.object({
    step: zod_1.z.string(),
    name: zod_1.z.string(),
    customers: zod_1.z.array(zod_1.z.object({
        customerId: zod_1.z.string(),
    })),
    mainAddress: zod_1.z.union([
        zod_1.z.object({
            existingAddressId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
            newAddress: zod_1.z.union([address_types_1.CreateAddressSchema, zod_1.z.null()]),
        }),
        zod_1.z.null(),
    ]),
    billingAddress: zod_1.z.union([
        zod_1.z.object({
            existingAddressId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
            newAddress: address_types_1.CreateAddressSchema,
        }),
        zod_1.z.null(),
    ]),
    termsAndConditions: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
});
exports.CreateQuoteResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.QuoteOverviewSchema = zod_1.z.object({
    id: zod_1.z.string(),
    number: zod_1.z.number(),
    status: zod_1.z.nativeEnum(sharedStatus_types_1.QuoteStatus),
    name: zod_1.z.string(),
    customers: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        companyName: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        email: zod_1.z.string(),
        phoneNumber: zod_1.z.string(),
    })),
    mainAddress: zod_1.z.union([address_types_1.NewAddressSchema, zod_1.z.null()]),
});
exports.GetQuotesResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.QuoteOverviewSchema),
});
exports.GetQuotesQuerySchema = zod_1.z.object({
    search: zod_1.z.string().optional(),
    customerId: zod_1.z.string().optional(),
});
exports.GetQuoteStep1Response = zod_1.z.object({
    data: exports.CreateQuoteRequestSchema,
});
exports.QuoteStep2RequestSchema = zod_1.z.object({
    step: zod_1.z.string(),
    notes: zod_1.z.string().optional(),
    attachments: zod_1.z.array(zod_1.z.object(attachment_types_1.AttachmentSchema)),
    priceBook: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().optional(),
        priceBookItemId: zod_1.z.string(),
        lineItemNumber: zod_1.z.number(),
        quantity: zod_1.z.number(),
        isOptional: zod_1.z.boolean().optional(),
        mainCustomerShare: zod_1.z.number(),
        secondaryCustomerShare: zod_1.z.number(),
        customerNotes: zod_1.z.string().optional(),
        enableShare: zod_1.z.boolean().optional(),
        customerShares: zod_1.z
            .array(zod_1.z.object({
            customerId: zod_1.z.string(),
            sharePercentage: zod_1.z.number(),
            shareAmount: zod_1.z.number(),
        }))
            .optional(),
    })),
});
exports.QuoteDetailsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    number: zod_1.z.number(),
    total: zod_1.z.number(),
    mainCustomerTotal: zod_1.z.number(),
    secondaryCustomerTotal: zod_1.z.number(),
    status: zod_1.z.nativeEnum(sharedStatus_types_1.QuoteStatus),
    currentStep: zod_1.z.string(),
    step1: exports.CreateQuoteRequestSchema,
    step2: exports.QuoteStep2RequestSchema,
    portalSelectedLineItems: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.QuotesDetailsResponseSchema = zod_1.z.object({
    data: exports.QuoteDetailsSchema,
});
exports.QuoteStep3RequestSchema = zod_1.z.object({
    selectedAttachments: zod_1.z.array(zod_1.z.string()),
});
const QuotePriceBookItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    quantity: zod_1.z.number(),
    itemTotal: zod_1.z.number(),
    price: zod_1.z.number(),
    wholesalePrice: zod_1.z.number(),
    unit: zod_1.z.nativeEnum(priceBook_types_1.UnitType),
    mainCustomerShare: zod_1.z.number(),
    secondaryCustomerShare: zod_1.z.number(),
    mainCustomerShareValue: zod_1.z.number(),
    secondaryCustomerShareValue: zod_1.z.number(),
    enableShare: zod_1.z.boolean().optional(),
    customerSharesTotal: zod_1.z.number(),
    customerShares: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        customerId: zod_1.z.string(),
        sharePercentage: zod_1.z.number(),
        shareAmount: zod_1.z.number(),
        taxBreakdown: tax_types_1.GSTBreakdownSchema,
    })),
    notes: zod_1.z.string().optional(),
    customerNotes: zod_1.z.string().optional(),
    isOptional: zod_1.z.boolean().optional(),
    taxBreakdown: tax_types_1.GSTBreakdownSchema,
});
exports.FullQuoteSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    number: zod_1.z.number(),
    status: zod_1.z.nativeEnum(sharedStatus_types_1.QuoteStatus),
    step: zod_1.z.string(),
    notes: zod_1.z.string().optional(),
    updatedAt: zod_1.z.date(),
    customers: zod_1.z.array(customer_types_1.CustomerSchema),
    priceBook: zod_1.z.array(QuotePriceBookItemSchema),
    totalExTax: zod_1.z.number(),
    tax: zod_1.z.number(),
    quoteTotal: zod_1.z.number(),
    quoteTotalShares: zod_1.z.number(),
    quoteTotalWholesale: zod_1.z.number(),
    netProfit: zod_1.z.number(),
    profitPercentage: zod_1.z.string(),
    mainCustomerTotal: zod_1.z.number(),
    secondaryCustomerTotal: zod_1.z.number(),
    selectedAttachments: zod_1.z.array(zod_1.z.string()),
    rawAttachments: zod_1.z.array(zod_1.z.object(attachment_types_1.AttachmentSchema)),
    signature: zod_1.z.object(attachment_types_1.AttachmentSchema).optional(),
    attachments: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        type: zod_1.z.union([zod_1.z.nativeEnum(attachment_types_1.AttachmentType), zod_1.z.string()]),
        name: zod_1.z.string(),
        width: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]),
        height: zod_1.z.union([zod_1.z.number(), zod_1.z.null()]),
        url: zod_1.z.string(),
    })),
    mainAddress: zod_1.z.union([address_types_1.NewAddressSchema, zod_1.z.null()]),
    additionalTermsAndConditions: zod_1.z.string().optional(),
    jobId: zod_1.z.string().optional(),
    jobStatus: zod_1.z.nativeEnum(sharedStatus_types_1.JobStatus).optional(),
    portalAcceptedAt: zod_1.z.coerce.date().nullish(),
    portalAcceptorName: zod_1.z.string().nullish(),
    portalRejectedAt: zod_1.z.coerce.date().nullish(),
    portalRejectionReason: zod_1.z.string().nullish(),
    portalChangesRequestedAt: zod_1.z.coerce.date().nullish(),
    portalChangesRequestMessage: zod_1.z.string().nullish(),
});
exports.FullQuoteResponseSchema = zod_1.z.object({
    data: exports.FullQuoteSchema,
});
exports.QuoteStatusRequestSchema = zod_1.z.object({
    status: zod_1.z.nativeEnum(sharedStatus_types_1.QuoteStatus),
    step: zod_1.z.string().optional(),
});
exports.QuoteStatusResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        jobId: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    }),
});
exports.SaveQuoteSignatureRequestSchema = zod_1.z.object({
    signature: zod_1.z.object(attachment_types_1.AttachmentSchema),
});
exports.CustomerInvoiceBreakdownSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    email: zod_1.z.string(),
    phoneNumber: zod_1.z.string(),
    invoicedAmount: zod_1.z.number(),
    paidAmount: zod_1.z.number(),
    balanceAmount: zod_1.z.number(),
    customerShareAmount: zod_1.z.number(),
    customerPaidAmount: zod_1.z.number(),
    customerInvoicedAmount: zod_1.z.number(),
    customerBalanceAmount: zod_1.z.number(),
    invoices: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        amount: zod_1.z.number(),
        dueDate: zod_1.z.string().date(),
        createdAt: zod_1.z.string().date(),
        status: zod_1.z.nativeEnum(invoices_types_1.InvoiceStatus),
    })),
});
exports.QuoteInvoiceBreakdownSchema = zod_1.z.object({
    quoteLineItems: zod_1.z.array(QuotePriceBookItemSchema),
    variationLineItems: zod_1.z.array(QuotePriceBookItemSchema),
    customers: zod_1.z.array(exports.CustomerInvoiceBreakdownSchema),
});
exports.QuoteInvoiceBreakdownResponseSchema = zod_1.z.object({
    data: exports.QuoteInvoiceBreakdownSchema,
});
exports.SendQuoteSchema = zod_1.z.object({
    emails: zod_1.z.string(),
    subject: zod_1.z.string(),
    message: zod_1.z.string(),
    sendCopyToUser: zod_1.z.boolean(),
});
exports.SendMultipleQuotesSchema = zod_1.z.object({
    quoteIds: zod_1.z.array(zod_1.z.string()).min(1),
    emails: zod_1.z.string(),
    subject: zod_1.z.string(),
    message: zod_1.z.string(),
    sendCopyToUser: zod_1.z.boolean(),
});
